<template>
  <div class="system-builder__cta--container">
    <div v-for="button in sharedState.currentStep.stickyNavigationOptions.buttons" :class="[{'disabled-button': currentStepValidation(button.requireStepValidation)}, button.buttonClass]" :data-link="button.linkTo" @click="handleButtonClick">
      {{button.text}}
    </div>
  </div>
</template>

<script>
  import store from '../../store/index'
  import router from '../../router'

  export default {
    name: 'footerNav',
    data () {
      return {
        sharedState: store.state
      }
    },
    methods: {
      updateCurrentRoute: function () {
        store.updateCurrentStateRoute(router.history.current.name)
      },
      checkButtonRequireValidation: function (buttonObj) {
        if (buttonObj.requireStepValidation) {
          return true
        } else {
          return false
        }
      },
      handleButtonClick: function (event) {
        var linkTo = event.target.attributes['data-link'].value

        function goToStep () {
          router.push({name: linkTo})
          store.updateCurrentStateRoute(linkTo)
        }

        // Validation
        switch (linkTo) {
          case 'selectVehicle':
            goToStep()
            break
          case 'selectSystem':
            if (this.sharedState.steps.selectVehicle.passedValidation) {
              goToStep()
            }
            break
          case 'selectRemote':
            if (this.sharedState.steps.selectSystem.passedValidation) {
              goToStep()
            }
            break
          case 'viewSystem':
            goToStep()
            break
          case 'contactInfo':
            goToStep()
            break
          case 'contactDealer':
            if (this.sharedState.steps.viewSystem.passedValidation) {
              goToStep()
            }
            break
          case 'print':
            window.print()
            break
          case '-1':
            goToStep()
            break

          default:
        }
      },
      currentStepValidation (requireVal) {
        if (requireVal === true) {
          if (this.sharedState.currentStep.passedValidation === false) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    mounted: function () {
      this.updateCurrentRoute()
    }
  }
</script>



// WEBPACK FOOTER //
// stickyFooterNavigation.vue?7c53fc3a